const cssVar = (name: string, fallback: string) => `var(${name}, ${fallback})`;

export const THEME_CSS_VARS = {
  primary: '--app-primary',
  primaryHover: '--app-primary-hover',
  darkSurface: '--app-dark-surface',
  darkSurfaceAlt: '--app-dark-surface-alt',
  darkAccent: '--app-dark-accent',
  darkAccentSoft: '--app-dark-accent-soft',
  darkBorderStrong: '--app-dark-border-strong',
  darkGlowPrimary: '--app-dark-glow-primary',
  darkGlowSecondary: '--app-dark-glow-secondary',
  darkCustom1: '--app-dark-custom-1',
  darkCustom2: '--app-dark-custom-2',
  darkBackground: '--app-dark-bg',
  darkCardBackground: '--app-dark-card-bg',
  darkText: '--app-dark-text',
  darkTextSecondary: '--app-dark-text-secondary',
  darkBorder: '--app-dark-border',
  darkShadow: '--app-dark-shadow',
  lightSurface: '--app-light-surface',
  lightSurfaceAlt: '--app-light-surface-alt',
  lightAccent: '--app-light-accent',
  lightAccentSoft: '--app-light-accent-soft',
  lightBorderStrong: '--app-light-border-strong',
  lightGlowPrimary: '--app-light-glow-primary',
  lightGlowSecondary: '--app-light-glow-secondary',
  lightCustom1: '--app-light-custom-1',
  lightCustom2: '--app-light-custom-2',
  lightBackground: '--app-light-bg',
  lightCardBackground: '--app-light-card-bg',
  lightText: '--app-light-text',
  lightTextSecondary: '--app-light-text-secondary',
  lightBorder: '--app-light-border',
  lightShadow: '--app-light-shadow',
  statusSuccess: '--app-status-success',
  statusSuccessSoft: '--app-status-success-soft',
  statusSuccessText: '--app-status-success-text',
  statusWarning: '--app-status-warning',
  statusWarningSoft: '--app-status-warning-soft',
  statusWarningText: '--app-status-warning-text',
  statusError: '--app-status-error',
  statusErrorSoft: '--app-status-error-soft',
  statusErrorText: '--app-status-error-text',
  statusInfo: '--app-status-info',
  statusInfoSoft: '--app-status-info-soft',
  statusInfoText: '--app-status-info-text'
};

export const tokens = {
    // Shortcuts for easier access
    primary: cssVar(THEME_CSS_VARS.primary, '#B2140F'),
    dark: {
      surface: cssVar(THEME_CSS_VARS.darkSurface, 'rgba(20, 28, 40, 0.95)'),
      surfaceAlt: cssVar(THEME_CSS_VARS.darkSurfaceAlt, 'rgba(30, 40, 56, 0.95)'),
      accent: cssVar(THEME_CSS_VARS.darkAccent, '#E84C3D'),
      accentSoft: cssVar(THEME_CSS_VARS.darkAccentSoft, 'rgba(232, 76, 61, 0.18)'),
      borderStrong: cssVar(THEME_CSS_VARS.darkBorderStrong, 'rgba(255, 255, 255, 0.28)'),
      glowPrimary: cssVar(THEME_CSS_VARS.darkGlowPrimary, 'rgba(232, 76, 61, 0.2)'),
      glowSecondary: cssVar(THEME_CSS_VARS.darkGlowSecondary, 'rgba(35, 60, 90, 0.35)'),
      custom1: cssVar(THEME_CSS_VARS.darkCustom1, '#0D3559'),
      custom2: cssVar(THEME_CSS_VARS.darkCustom2, '#1f9aff'),
      background: cssVar(THEME_CSS_VARS.darkBackground, 'linear-gradient(160deg, #0a1929 0%, #1a2332 100%)'),
      cardBackground: cssVar(THEME_CSS_VARS.darkCardBackground, 'rgba(25, 35, 50, 0.95)'),
      text: cssVar(THEME_CSS_VARS.darkText, '#FFFFFF'),
      textSecondary: cssVar(THEME_CSS_VARS.darkTextSecondary, '#B0BEC5'),
      border: cssVar(THEME_CSS_VARS.darkBorder, 'rgba(255, 255, 255, 0.12)'),
      shadow: cssVar(THEME_CSS_VARS.darkShadow, '0 20px 46px rgba(0, 0, 0, 0.5)')
    },
    light: {
      surface: cssVar(THEME_CSS_VARS.lightSurface, '#FFFFFF'),
      surfaceAlt: cssVar(THEME_CSS_VARS.lightSurfaceAlt, '#F2F4F8'),
      accent: cssVar(THEME_CSS_VARS.lightAccent, '#B2140F'),
      accentSoft: cssVar(THEME_CSS_VARS.lightAccentSoft, 'rgba(178, 20, 15, 0.12)'),
      borderStrong: cssVar(THEME_CSS_VARS.lightBorderStrong, 'rgba(0, 0, 0, 0.28)'),
      glowPrimary: cssVar(THEME_CSS_VARS.lightGlowPrimary, 'rgba(178, 20, 15, 0.12)'),
      glowSecondary: cssVar(THEME_CSS_VARS.lightGlowSecondary, 'rgba(13, 53, 89, 0.08)'),
      custom1: cssVar(THEME_CSS_VARS.lightCustom1, '#0D3559'),
      custom2: cssVar(THEME_CSS_VARS.lightCustom2, '#FFB020'),
      background: cssVar(THEME_CSS_VARS.lightBackground, 'linear-gradient(160deg, #FAFAFA 0%, #F5F5F5 100%)'),
      cardBackground: cssVar(THEME_CSS_VARS.lightCardBackground, 'rgba(255, 255, 255, 0.98)'),
      text: cssVar(THEME_CSS_VARS.lightText, '#000000'),
      textSecondary: cssVar(THEME_CSS_VARS.lightTextSecondary, '#616161'),
      border: cssVar(THEME_CSS_VARS.lightBorder, 'rgba(0, 0, 0, 0.12)'),
      shadow: cssVar(THEME_CSS_VARS.lightShadow, '0 20px 46px rgba(9, 32, 56, 0.22)')
    },
  
  colors: {
    primary: cssVar(THEME_CSS_VARS.primary, '#B2140F'),
    primaryHover: cssVar(THEME_CSS_VARS.primaryHover, '#8D100C'),
    
    dark: {
      surface: cssVar(THEME_CSS_VARS.darkSurface, 'rgba(20, 28, 40, 0.95)'),
      surfaceAlt: cssVar(THEME_CSS_VARS.darkSurfaceAlt, 'rgba(30, 40, 56, 0.95)'),
      accent: cssVar(THEME_CSS_VARS.darkAccent, '#E84C3D'),
      accentSoft: cssVar(THEME_CSS_VARS.darkAccentSoft, 'rgba(232, 76, 61, 0.18)'),
      borderStrong: cssVar(THEME_CSS_VARS.darkBorderStrong, 'rgba(255, 255, 255, 0.28)'),
      glowPrimary: cssVar(THEME_CSS_VARS.darkGlowPrimary, 'rgba(232, 76, 61, 0.2)'),
      glowSecondary: cssVar(THEME_CSS_VARS.darkGlowSecondary, 'rgba(35, 60, 90, 0.35)'),
      custom1: cssVar(THEME_CSS_VARS.darkCustom1, '#0D3559'),
      custom2: cssVar(THEME_CSS_VARS.darkCustom2, '#1f9aff'),
      background: cssVar(THEME_CSS_VARS.darkBackground, 'linear-gradient(160deg, #0a1929 0%, #1a2332 100%)'),
      cardBackground: cssVar(THEME_CSS_VARS.darkCardBackground, 'rgba(25, 35, 50, 0.95)'),
      text: cssVar(THEME_CSS_VARS.darkText, '#FFFFFF'),
      textSecondary: cssVar(THEME_CSS_VARS.darkTextSecondary, '#B0BEC5'),
      border: cssVar(THEME_CSS_VARS.darkBorder, 'rgba(255, 255, 255, 0.12)'),
      shadow: cssVar(THEME_CSS_VARS.darkShadow, '0 20px 46px rgba(0, 0, 0, 0.5)')
    },
    
    light: {
      surface: cssVar(THEME_CSS_VARS.lightSurface, '#FFFFFF'),
      surfaceAlt: cssVar(THEME_CSS_VARS.lightSurfaceAlt, '#F2F4F8'),
      accent: cssVar(THEME_CSS_VARS.lightAccent, '#B2140F'),
      accentSoft: cssVar(THEME_CSS_VARS.lightAccentSoft, 'rgba(178, 20, 15, 0.12)'),
      borderStrong: cssVar(THEME_CSS_VARS.lightBorderStrong, 'rgba(0, 0, 0, 0.28)'),
      glowPrimary: cssVar(THEME_CSS_VARS.lightGlowPrimary, 'rgba(178, 20, 15, 0.12)'),
      glowSecondary: cssVar(THEME_CSS_VARS.lightGlowSecondary, 'rgba(13, 53, 89, 0.08)'),
      custom1: cssVar(THEME_CSS_VARS.lightCustom1, '#0D3559'),
      custom2: cssVar(THEME_CSS_VARS.lightCustom2, '#FFB020'),
      background: cssVar(THEME_CSS_VARS.lightBackground, 'linear-gradient(160deg, #FAFAFA 0%, #F5F5F5 100%)'),
      cardBackground: cssVar(THEME_CSS_VARS.lightCardBackground, 'rgba(255, 255, 255, 0.98)'),
      text: cssVar(THEME_CSS_VARS.lightText, '#000000'),
      textSecondary: cssVar(THEME_CSS_VARS.lightTextSecondary, '#616161'),
      border: cssVar(THEME_CSS_VARS.lightBorder, 'rgba(0, 0, 0, 0.12)'),
      shadow: cssVar(THEME_CSS_VARS.lightShadow, '0 20px 46px rgba(9, 32, 56, 0.22)')
    }
  },

  status: {
    success: cssVar(THEME_CSS_VARS.statusSuccess, '#2e7d32'),
    successSoft: cssVar(THEME_CSS_VARS.statusSuccessSoft, '#e7f4ea'),
    successText: cssVar(THEME_CSS_VARS.statusSuccessText, '#1b5e20'),
    warning: cssVar(THEME_CSS_VARS.statusWarning, '#ed6c02'),
    warningSoft: cssVar(THEME_CSS_VARS.statusWarningSoft, '#fff4e5'),
    warningText: cssVar(THEME_CSS_VARS.statusWarningText, '#7a3d00'),
    error: cssVar(THEME_CSS_VARS.statusError, '#d32f2f'),
    errorSoft: cssVar(THEME_CSS_VARS.statusErrorSoft, '#fdecea'),
    errorText: cssVar(THEME_CSS_VARS.statusErrorText, '#b71c1c'),
    info: cssVar(THEME_CSS_VARS.statusInfo, '#0288d1'),
    infoSoft: cssVar(THEME_CSS_VARS.statusInfoSoft, '#e3f2fd'),
    infoText: cssVar(THEME_CSS_VARS.statusInfoText, '#01579b')
  },
  
  spacing: {
    containerPadding: { xs: 4, md: 6 },
    cardPadding: { xs: 2.5, md: 3 },
    appBarPadding: { xs: 2, md: 4 },
    sectionGap: 3,
    paragraphGap: 2
  },
  
  typography: {
    heading: {
      fontWeight: 700,
      textDecoration: 'underline',
      textDecorationThickness: '2px'
    },
    subtitle: {
      fontWeight: 600
    },
    body: {
      lineHeight: 1.7
    }
  },
  
  effects: {
    transition: 'all 0.3s ease-in-out',
    borderRadius: {
      card: 3,
      image: 8,
      button: 2
    },
    hover: {
      imageScale: 1.02,
      buttonScale: 1.05
    }
  }
};

export const getBackgroundSx = (darkMode: boolean) => ({
  minHeight: '100vh',
  width: '100%',
  background: darkMode ? tokens.colors.dark.background : tokens.colors.light.background,
  display: 'flex',
  flexDirection: 'column' as const,
  transition: tokens.effects.transition
});

export const getCardSx = (darkMode: boolean) => ({
  backgroundColor: darkMode ? tokens.colors.dark.cardBackground : tokens.colors.light.cardBackground,
  color: darkMode ? tokens.colors.dark.text : tokens.colors.light.text,
  borderRadius: tokens.effects.borderRadius.card,
  boxShadow: darkMode ? tokens.colors.dark.shadow : tokens.colors.light.shadow,
  p: tokens.spacing.cardPadding,
  transition: tokens.effects.transition,
  border: `1px solid ${darkMode ? tokens.colors.dark.border : tokens.colors.light.border}`
});
